<h1>Steps Menu</h1>
<div class="fake--screen">
  <div class="fake--menu">
      <app-steps [model]="menuItems" [(activeIndex)]="activeIndex"></app-steps>
  </div>
</div>
<app-button (onClick)="submit()" text="Next"></app-button>